import type {
  SearchOptionsResponseDto,
  TeamsResponseDto,
  TeamsSduiResponseDto,
} from '@nomiss/sdk';
import {
  TeamsResponseDtoFromJSON,
  TeamsSduiResponseDtoFromJSON,
} from '@nomiss/sdk';
import {
  executeSdkEnvelopeRequest,
  executeSdkRawRequest,
} from './api-request.util';
import { teamsApi } from './sdk-client';

export async function getTeamsByLeagueCodes(
  leagueCodes: string[],
): Promise<TeamsResponseDto> {
  return executeSdkEnvelopeRequest({
    request: () =>
      teamsApi.teamsControllerGetTeamsByLeagueCodesV1Raw({ leagueCodes }),
    parse: TeamsResponseDtoFromJSON,
    fallback: 'Failed to load teams',
  });
}

export async function getTeamsSdui(
  sportCode: string,
  leagueCodes: string[],
): Promise<TeamsSduiResponseDto> {
  return executeSdkEnvelopeRequest({
    request: () =>
      teamsApi.teamsControllerGetTeamsSduiV1Raw({ sportCode, leagueCodes }),
    parse: TeamsSduiResponseDtoFromJSON,
    fallback: 'Failed to load teams SDUI',
  });
}

export type SearchTeamsParams = {
  sportCode: string;
  leagueCodes: string[];
  query?: string;
  cursor?: string;
  limit?: number;
};

export async function searchTeams(
  params: SearchTeamsParams,
): Promise<SearchOptionsResponseDto> {
  return executeSdkRawRequest<SearchOptionsResponseDto>({
    request: () =>
      teamsApi.teamsControllerSearchTeamsV1Raw({
        sportCode: params.sportCode,
        leagueCodes: params.leagueCodes.join(','),
        query: params.query,
        cursor: params.cursor,
        limit: params.limit,
      }),
    fallback: 'Failed to search teams',
  });
}
